import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectInstructionLink } from '~/src/redux/offers/offers.selectors';
import { setInstructionLinkAction } from '~/src/redux/offers/offers.slice';
import { CmsService } from '~/src/services/cms.service';
import { CmsCategoryCodeEnum, CmsProductSefUrlEnum } from '~/src/models/enums/cms.enum';

interface UseInstructionReturnInterface {
    getInstructionLink: (articleSefUrl?: string) => Promise<string | null>;
    openInstruction: (articleSefUrl?: string) => Promise<void>;
}

export const useInstruction = (): UseInstructionReturnInterface => {
    const dispatch = useDispatch();
    const instructionLink = useSelector(selectInstructionLink);

    const getInstructionLink = useCallback(
        async (articleSefUrl: string = 'user-manual'): Promise<string | null> => {
            try {
                if (instructionLink) {
                    return instructionLink;
                }

                const data = (await CmsService.getInstructionDataViaApi(
                    articleSefUrl,
                    CmsCategoryCodeEnum.FILES,
                    CmsProductSefUrlEnum.MTS_AGENTS,
                )) as string;

                if (data) {
                    dispatch(setInstructionLinkAction(data));
                    return data;
                }

                return null;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Ошибка загрузки инструкции:', error);
                return null;
            }
        },
        [instructionLink, dispatch],
    );

    const openInstruction = useCallback(
        async (articleSefUrl?: string) => {
            const link = await getInstructionLink(articleSefUrl);
            if (link) {
                window.open(link, '_blank');
            }
        },
        [getInstructionLink],
    );

    return {
        getInstructionLink,
        openInstruction,
    };
};
